import React, {Component} from 'react';
import {useToasts, withToastManager} from "react-toast-notifications";
import * as queryString from "query-string";
import Footer from "../Footer";
const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATCH;
const HOME_PAGE = process.env.REACT_APP_HOME_PAGE;

class Token extends Component {

    constructor() {
        super();
        this.state = {
            token: ''
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('componentDidUpdate');
    }

    componentDidMount() {
        let {token,message} = queryString.parse(this.props.location.search);
        console.log('componentDidMount');
        this.input.value = token??"";

        if (message !== undefined) {
            this.props.toastManager.add(message, {
                appearance: 'error',
                autoDismiss: true,
            });
        }
    }

    gotoMain() {
        let token = this.input.value.trim();
        if (token === "") {
            this.props.toastManager.add("Please fill in token or click button to get new token.", {
                appearance: 'error',
                autoDismiss: true,
            });
        } else{
            // this.props.history.push(PUBLIC_PATH + "/credit-note?token=" + token);
            this.props.history.push(PUBLIC_PATH + "/main?token=" + token);
        }


    }

    getToken() {
        let url = 'https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appId=Bh5WbbzNnpYVcubwaeIXjRMWA3fB3eBQP9F6WHa0Kco1?redirectUrl=' + HOME_PAGE
    }

    toastMsg(content) {
        const {addToast} = useToasts();
        addToast(content, {
            appearance: 'error',
            autoDismiss: true,
        });
    }


    render() {

        return (
            <>
                <main className="dash-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card spur-card">
                                    <div className="card-body ">
                                        <div className="form-group">
                                            <div className="row d-flex justify-content-center">
                                                <div className="col-xl-5">
                                                    <div className="input-group">
                                                        <a
                                                            target={'_blank'}
                                                            href={'https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=NqZvBfQCXaOC96tpsh4tBjBi4UXSU3V6MeGE82qM4Fw1&redirectUrl=https%3A%2F%2Fapps.2app.dk%2Fimport-tool-economic%2Ffrontend'}
                                                            className="btn btn-light">Get token
                                                        </a>
                                                        <input name="token" className="form-control"
                                                               ref={input => this.input = input}
                                                               placeholder={"Input your token or click button to get token."}/>
                                                        <button type="button"
                                                                onClick={this.gotoMain.bind(this)}
                                                                className="btn btn-light">Next
                                                        </button>
                                                    </div>

                                                </div>
                                                <div className="toast">
                                                    <div className="toast-header">
                                                        Toast Header
                                                    </div>
                                                    <div className="toast-body">
                                                        Some text inside the toast body
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </>
        );
    }


}


export default withToastManager(Token);
